<template>
	<div class="page-nation">
    <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current_page"
        :page-sizes="page_sizes"
        :page-size="page_limit"
        layout="total, sizes, prev, pager, next"
        :total="total">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    name: "PageNation",
    props: {
      total: {
        type: Number
      }, // 总条数
      current_page: {
        type: Number
      },// 当前页
      page_limit: {
        type: Number
      },// 每页多少条
      page_sizes:{
        type:Array // 每页允许多少条list [10, 20, 50, 100],
      }
    },
    data() {
      return {
        page: {
          current_page: 1,
          page_limit: 10
        }
      };
    },
    methods: {
      // // 每页查看条数变化
      handleSizeChange(val) {
        this.page.page_limit = val;
        this.page.current_page = 1;
        this.page.type = 'size';
        this.$emit('pageChange', this.page);
      },
      // 当前页码变化
      handleCurrentChange(val) {
        this.page.current_page = val;
        this.$emit('pageChange', this.page);
      }
    },
  }
</script>

<style scoped lang="scss">
.page-nation{
  width: 100%;
  margin: 30px auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/PageNation.vue